import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_PROVIDER_STATUS = 'UPDATE_PROVIDER_STATUS';
export const UPDATE_PROVIDER_STATUS_SUCCESS = 'UPDATE_PROVIDER_STATUS_SUCCESS';
export const UPDATE_PROVIDER_STATUS_FAILURE = 'UPDATE_PROVIDER_STATUS_FAILURE';

// Action Creators
export const fetchUpdateProviderStatus = () => ({
  type: UPDATE_PROVIDER_STATUS,
});

export const fetchUpdateProviderStatusSuccess = (data) => ({
  type: UPDATE_PROVIDER_STATUS_SUCCESS,
  payload: data,
});

export const fetchUpdateProviderStatusFailure = (error) => ({
  type: UPDATE_PROVIDER_STATUS_FAILURE,
  payload: error,
});

// Thunk Function
export const updateProviderStatusCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateProviderStatus(data, external));
    try {
      const response = await putMethodWithToken(
        external?.tab === 1
          ? url.updateCustomersStatusSuperAdmin
          : url.updateProviderStatus,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateProviderStatusSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateProviderStatusFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateProviderStatusFailure(error.message));
    }
  };
};
